export default "__VITE_ASSET__BBl8I3kd__"